// @core/api/endpoints/document/get_clause.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentClauseResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get clause
 * Returns a clause by ID.
 */
export async function GetClause(
  clause_id: string,
  options?: RequestOptions
): Promise<DocumentClauseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/clauses/:clause_id`;
  requestPath = requestPath.replace(':clause_id', encodeURIComponent(clause_id));
  const requestOptions = options;
  return client.get<DocumentClauseResponse>(requestPath, { ...requestOptions });
}
